import { ReactNode, KeyboardEvent } from "react";
import { Card } from "react-bootstrap";

interface DashboardMetricProps {
    title: string | ReactNode;
    value: number | string | ReactNode;
    onClick?: () => void;
    className?: string;
    isActive?: boolean;
    footer?: ReactNode;
}

export function DashboardMetric({
    title,
    value,
    onClick,
    className,
    isActive,
    footer,
}: Readonly<DashboardMetricProps>) {
    const headerClassName = isActive ? "bg-primary text-white" : "";
    const bodyClassName = isActive ? "bg-canvas" : "";

    const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
        if (e.key === "Enter" || e.key === " ") {
            onClick?.();
        }
    };

    return (
        <Card
            className={`dashboard-metric text-center mt-1 mb-1 ${onClick ? "clickable" : ""} ${isActive ? "border-primary" : ""} ${className ?? ""}`}
            onClick={onClick}
            tabIndex={onClick ? 0 : undefined}
            onKeyDown={handleKeyDown}
        >
            <Card.Header className={headerClassName}>{title}</Card.Header>
            <Card.Body className={bodyClassName}>
                <Card.Text className="dashboard-metric-value">{value}</Card.Text>
            </Card.Body>
            {!!footer && (
                <Card.Footer className={`p-0 ${isActive ? "bg-canvas" : ""}`} style={{ fontSize: ".8rem" }}>
                    {footer}
                </Card.Footer>
            )}
        </Card>
    );
}
